import {
  route,
} from '@app/Routing/helpers'
import { accessPermission } from '@access/permissions'

import {
  PRODUCTS_LIST,
  PRODUCTS_ADD,
} from '@app/Seller/Products/accessTokens'

const ProductsBase = () => import('@app/Seller/Components/Base')
const ProductsList = () => import('@app/Seller/Products/List')
const ProductsAdd = () => import('@app/Seller/Products/Add')

const MODEL = 'products'

const BASE = `${MODEL}/`

const LIST = ''
const ADD = 'add/'
const EDIT = ':id/edit/'

export const PRODUCTS_PREFIX = `${MODEL}:`
const p = name => PRODUCTS_PREFIX + name

export const PRODUCTS_BASE_NAME = p('base')
export const PRODUCTS_LIST_NAME = p('list')
export const PRODUCTS_INFO_NAME = p('info')
export const PRODUCTS_VALIDATION_NAME = p('validation')
export const PRODUCTS_IMPORT_NAME = p('import')
export const PRODUCTS_ADD_NAME = p('add')
export const PRODUCTS_EDIT_NAME = p('edit')

export function createRoutes(options) {
  return [
    route(BASE, ProductsBase, PRODUCTS_BASE_NAME, {
      meta: accessPermission(PRODUCTS_LIST, options),
      redirect: { name: PRODUCTS_LIST_NAME },
      children: [
        route(LIST, ProductsList, PRODUCTS_LIST_NAME, {
          meta: accessPermission(PRODUCTS_LIST, options),
        }),
        route(ADD, ProductsAdd, PRODUCTS_ADD_NAME, {
          meta: { ...accessPermission(PRODUCTS_ADD, options), needKey: true },
        }),
        route(EDIT, ProductsAdd, PRODUCTS_EDIT_NAME, {
          meta: { ...accessPermission(PRODUCTS_ADD, options), needKey: true },
        }),
      ],
    }),
  ]
}
